export function delayedPromise(response, ms = 500) {
  return new Promise((resolve) => setTimeout(()=>resolve(response), ms));
}
